import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from 'features/auth/authSelectors';

type FilterType = 'applicationFilters' | 'jobFilters' | 'jobseekerFilters';

const useFilterAccess = (filterType: FilterType) => {
  const user = useSelector(selectUser);

  const availableFilters = useMemo(
    () => user?.clientTierConfiguration?.[filterType] ?? [],
    [filterType, user?.clientTierConfiguration]
  );

  const hasAccessToFilter = useCallback(
    (filterKey: string): boolean => availableFilters.includes(filterKey),
    [availableFilters]
  );

  return {
    availableFilters,
    hasAccessToFilter
  };
};

export default useFilterAccess;
